'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { Building2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PageShell } from '@/components/ui/page-shell';
import { CANDIDATE_PUBLIC_ROUTES } from '@/lib/candidate-public-routes';

export default function CompanyDataError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Preserve an operational signal without exposing service details to users.
    // eslint-disable-next-line no-console
    console.error('[public-company-unavailable]', error.digest || error.message);
  }, [error]);

  return (
    <PageShell width="sm" padded className="flex min-h-[55vh] flex-col items-center justify-center text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-muted">
        <Building2 aria-hidden="true" className="h-7 w-7 text-muted-foreground" />
      </div>
      <h1 className="text-2xl font-semibold text-foreground">Company information is temporarily unavailable</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        We could not confirm the latest public company details. No profile has been marked as removed.
      </p>
      <div className="flex flex-wrap justify-center gap-3">
        <Button onClick={reset}>Try again</Button>
        <Button asChild variant="outline">
          <Link href={CANDIDATE_PUBLIC_ROUTES.companies}>Companies</Link>
        </Button>
        <Button asChild variant="ghost">
          <Link href="/jobs">Browse jobs</Link>
        </Button>
      </div>
    </PageShell>
  );
}
